import React, { useState } from 'react';
import { reportService } from '../services/firebaseService';

const TestReportsPage: React.FC = () => {
  const [reports, setReports] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const analyzeReports = async () => {
    setLoading(true);
    setError(null);
    
    try {
      console.log('🔍 Firebase reports analiz ediliyor...');
      const reportsData = await reportService.getAllReports(10);
      
      console.log('📊 Reports verisi:', reportsData);
      setReports(reportsData);
      
      // Detaylı analiz
      const statusCounts: { [key: string]: number } = {};
      const reasonCounts: { [key: string]: number } = {};
      
      reportsData.forEach(report => {
        statusCounts[report.status] = (statusCounts[report.status] || 0) + 1;
        reasonCounts[report.reason] = (reasonCounts[report.reason] || 0) + 1;
      });
      
      console.log('📈 Status dağılımı:', statusCounts);
      console.log('🏷️ Reason dağılımı:', reasonCounts);
      
      if (reportsData.length > 0) {
        console.log('🔍 İlk report örneği:', reportsData[0]);
        console.log('📝 Tüm alanlar:', Object.keys(reportsData[0]));
      }
      
    } catch (err: any) {
      console.error('❌ Reports analiz hatası:', err);
      setError(err.message || 'Reports analizi başarısız');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">🔍 Firebase Reports Analizi</h1>
      
      <div className="mb-6">
        <button
          onClick={analyzeReports}
          disabled={loading}
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg disabled:opacity-50"
        >
          {loading ? '⏳ Analiz Ediliyor...' : '🔍 Reports Analiz Et'}
        </button>
      </div>

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-6">
          <strong>Hata:</strong> {error}
        </div>
      )}

      {reports.length > 0 && (
        <div className="space-y-6">
          <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded">
            <strong>✅ Başarılı!</strong> {reports.length} report bulundu. Console'u kontrol edin.
          </div>

          <div className="grid gap-4">
            <h2 className="text-xl font-semibold">📋 Reports Listesi:</h2>
            {reports.map((report, index) => (
              <div key={report.id || index} className="bg-white p-4 rounded-lg shadow border">
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div>
                    <strong>ID:</strong> {report.id || 'N/A'}
                  </div>
                  <div>
                    <strong>Status:</strong> 
                    <span className={`ml-2 px-2 py-1 rounded text-xs ${
                      report.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                      report.status === 'reviewing' ? 'bg-blue-100 text-blue-800' :
                      report.status === 'resolved' ? 'bg-green-100 text-green-800' :
                      'bg-gray-100 text-gray-800'
                    }`}>
                      {report.status || 'N/A'}
                    </span>
                  </div>
                  <div>
                    <strong>Reporter ID:</strong> {report.reporterId || 'N/A'}
                  </div>
                  <div>
                    <strong>Reported User ID:</strong> {report.reportedUserId || 'N/A'}
                  </div>
                  <div>
                    <strong>Reason:</strong> {report.reason || 'N/A'}
                  </div>
                  <div>
                    <strong>Created At:</strong> {
                      report.createdAt ? 
                        new Date(report.createdAt.seconds * 1000).toLocaleString('tr-TR') 
                        : 'N/A'
                    }
                  </div>
                  <div className="col-span-2">
                    <strong>Description:</strong> {report.description || 'N/A'}
                  </div>
                  <div className="col-span-2">
                    <strong>Admin Notes:</strong> {report.adminNotes || 'N/A'}
                  </div>
                  <div className="col-span-2">
                    <strong>Tüm Alanlar:</strong> {Object.keys(report).join(', ')}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TestReportsPage; 